import {Button, Col, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import Back from "../layout/template/back";
import ApiService from "../../services/ApiService";
import GenericErrorModal from "../modal/genericErrorModal";
import DateTimeUtils from "../../services/DateTimeUtils";


const AdminReport = () => {

    const [from, setFrom] = useState();
    const [to, setTo] = useState()

    const [transactionFrom, setTransactionFrom] = useState();
    const [transactionTo, setTransactionTo] = useState()

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });
    const handleExportReport = () => {
        ApiService.getReportAllParticipantFromTo(DateTimeUtils.formatDateReport(from), DateTimeUtils.formatDateReport(to))
            .then(response => {
                if (response.ok){
                    response.blob().then(blob => {
                        handleBlobToDownload(blob, `partecipanti_dal_${from}_al${to}`)
                    })
                } else {
                    setErrorModal({
                        state: true,
                        title: "Errore nella generazione del report",
                        body: "ok"
                    })
                }
            })
    }

    const handleExportReportPartner = () => {
        ApiService.getReportPartnerOffer()
            .then(response => {
                if (response.ok){
                    response.blob().then(blob => {
                        handleBlobToDownload(blob, `utenti_partner_offer`)
                    })
                }else {
                    setErrorModal({
                        state: true,
                        title: "Errore nella generazione del report",
                        body: "ok"
                    })
                }
            })
    }

    const handleExportNewsLetter = () => {
        ApiService.getReportNewsLetter()
            .then(response => {
                if (response.ok){
                    response.blob().then(blob => {
                        handleBlobToDownload(blob, `utenti_newsletter`)
                    })
                }else {
                    setErrorModal({
                        state: true,
                        title: "Errore nella generazione del report",
                        body: "ok"
                    })
                }
            })
    }

    const handleExportTransaction = () => {
        ApiService.getReportTransaction(DateTimeUtils.formatDateReport(transactionFrom), DateTimeUtils.formatDateReport(transactionTo))
            .then(response => {
                if (response.ok){
                    response.blob().then(blob => {
                        handleBlobToDownload(blob, `transazioni`)
                    })
                }else {
                    setErrorModal({
                        state: true,
                        title: "Errore nella generazione del report",
                        body: "ok"
                    })
                }
            })
    }

    const handleBlobToDownload = (blob, name) => {
        const url = URL.createObjectURL(blob);

        // Create a link element to initiate the download
        const link = document.createElement('a');
        link.href = url;
        link.download = `${name}.xls`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>Report</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} sm={10} md={8} lg={4} xl={3}>
                            <Row>
                                <Col>
                                    <div className={'title-page-section mt-4 mb-4'}>
                                        <h2 className={'title'}>Partecipanti ai corsi</h2>
                                    </div>

                                    <Row>
                                        <Col lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label>Dal</Form.Label>
                                                <Form.Control type='date' value={from} onChange={(e) => setFrom(e.target.value)} placeholder="giorno"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label>Al</Form.Label>
                                                <Form.Control type='date' value={to} onChange={(e) => setTo(e.target.value)} placeholder="giorno"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Button
                                                variant={'primary'}
                                                type={'submit'}
                                                className={'fw-bold'}
                                                disabled={!from || !to}
                                                onClick={handleExportReport}
                                            >Esporta Partecipanti</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'title-page-section mt-4 mb-4'}>
                                        <h2 className={'title'}>Partner Offer</h2>
                                    </div>

                                    <Row>
                                        <Col lg={6}>
                                            <Button
                                                variant={'primary'}
                                                type={'submit'}
                                                className={'fw-bold'}
                                                onClick={handleExportReportPartner}
                                            >Esporta Partner</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'title-page-section mt-4 mb-4'}>
                                        <h2 className={'title'}>Newsletter</h2>
                                    </div>

                                    <Row>
                                        <Col lg={6}>
                                            <Button
                                                variant={'primary'}
                                                type={'submit'}
                                                className={'fw-bold'}
                                                onClick={handleExportNewsLetter}
                                            >Esporta Newsletter</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'title-page-section mt-4 mb-4'}>
                                        <h2 className={'title'}>Transazioni </h2>
                                    </div>

                                    <Row>
                                        <Col lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label>Dal</Form.Label>
                                                <Form.Control type='date' value={transactionFrom} onChange={(e) => setTransactionFrom(e.target.value)} placeholder="giorno"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group className="mb-4">
                                                <Form.Label>Al</Form.Label>
                                                <Form.Control type='date' value={transactionTo} onChange={(e) => setTransactionTo(e.target.value)} placeholder="giorno"/>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Button
                                                variant={'primary'}
                                                type={'submit'}
                                                className={'fw-bold'}
                                                disabled={!transactionFrom || !transactionTo}
                                                onClick={handleExportTransaction}
                                            >Esporta Transazioni</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Col>

                    </Row>
                </Col>

                <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

            </Row>
        </>

    );
}

export default AdminReport;